import RequestStepsQuery from "../../domain/core/request/RequestStepsQuery";
import { StepModel } from "../../domain/models/Steps";
import { IQueryRequestStepsRepository } from "../../domain/ports/request/IQueryRequestStepsRepository";
import QueryService from "../QueryService";

export class RequestStepsQueryService
  extends QueryService<StepModel>
  implements IQueryRequestStepsRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
  }
  public async findBySlug(slug: string): Promise<StepModel | null> {
    const response = await this.search({
      search: {
        filters: [{ field: "slug", operator: "=", value: slug }],
        limit: 10,
      },
    });
    return response.data?.[0] ?? null;
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const requestStepsQueryService = new RequestStepsQuery(
  new RequestStepsQueryService(BASE_URL, "request_steps"),
);

export { requestStepsQueryService };
